import { render, staticRenderFns } from "./AppTitlebar.vue?vue&type=template&id=51d68fd7&scoped=true"
import script from "./AppTitlebar.vue?vue&type=script&lang=js"
export * from "./AppTitlebar.vue?vue&type=script&lang=js"
import style0 from "./AppTitlebar.vue?vue&type=style&index=0&id=51d68fd7&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d68fd7",
  null
  
)

export default component.exports